// DS: i10.2
import React from 'react';
import IconWrap from '../IconWrap';
const Twitter = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M20.26 6.654a7.019 7.019 0 0 1-2.025.556 3.56 3.56 0 0 0 1.553-1.951c-.694.41-1.452.7-2.244.857a3.554 3.554 0 0 0-3.888-.868 3.539 3.539 0 0 0-2.153 4.088 10.056 10.056 0 0 1-7.295-3.692 3.455 3.455 0 0 0-.483 1.776 3.325 3.325 0 0 0 1.3 2.94A10.909 10.909 0 0 1 3.15 9.92v.045a3.791 3.791 0 0 0 3.118 3.463 2.576 2.576 0 0 1-.794.124 2.78 2.78 0 0 1-.598-.063 3.574 3.574 0 0 0 3.337 2.452A7.044 7.044 0 0 1 3 17.403a10.098 10.098 0 0 0 10.27.354A10.048 10.048 0 0 0 18.51 8.94c0-.153-.012-.306-.012-.46a7.14 7.14 0 0 0 1.761-1.826z"
    }))));
Twitter.displayName = 'Twitter';
export default Twitter;
